import './js/api';
import './js/students-modal';
import './js/renderUi';
import './js/back-to-top';
import './js/markupFilms';
import './js/api_movie';
import './js/loader';
import './js/pagination';
import './js/sort-top-film';
import './js/dark-theme';
import './js/typed';
